var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload system-upload-file" },
    [
      !_vm.uploading
        ? _c(
            "el-upload",
            {
              ref: "upload_" + _vm.type,
              attrs: {
                action: "#",
                drag: "",
                "auto-upload": false,
                accept: _vm.acceptType,
                limit: _vm.limitNum,
                "on-change": _vm.handleFile.bind(this, _vm.type),
                "on-remove": _vm.handleRemove.bind(this, _vm.type),
                "on-exceed": _vm.handleFileExceed.bind(this, _vm.type),
                "file-list": _vm.fileList,
              },
            },
            [
              _c("div", [
                _c("i", { staticClass: "el-icon-upload" }),
                _c("div", { staticClass: "el-upload__text" }, [
                  _c("em", { staticStyle: { color: "#3855F1" } }, [
                    _vm._v(" Click to upload "),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm.uploading
        ? _c("div", { staticClass: "parse" }, [_vm._v(" Uploading ")])
        : _vm._e(),
      _c("Progress", { attrs: { progress: _vm.uploadingProgress } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }